import { useState } from 'react';

import PersonCertificationBadgeData from './PersonCertificationBadgeData';

import { BASIC_INITIAL_STATE } from '../../../../common/utils/HttpHelper';

const INITIAL_PERSON_CERTIFICATION_BADGE_STATE = {
  ...BASIC_INITIAL_STATE
};

const usePersonCertificationBadgeData = () => {
  const [personCertificationBadgeState, setPersonCertificationBadgeState] = useState(INITIAL_PERSON_CERTIFICATION_BADGE_STATE);

  const getPersonCertificationBadgeByFileUrl = (fileUrl) => {
    return PersonCertificationBadgeData.getPersonCertificationBadgeByFileUrlData(fileUrl, personCertificationBadgeState, setPersonCertificationBadgeState);
  };

  const resetPersonCertificationBadgeState = () => {
    setPersonCertificationBadgeState({
      ...INITIAL_PERSON_CERTIFICATION_BADGE_STATE
    });
  };

  return {
    personCertificationBadgeState,
    setPersonCertificationBadgeState,
    getPersonCertificationBadgeByFileUrl,
    resetPersonCertificationBadgeState
  };
};

export default usePersonCertificationBadgeData;